import axios from 'axios';

const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID || 'YOUR_BOT_CLIENT_ID';
const DISCORD_CLIENT_SECRET = process.env.REACT_APP_DISCORD_CLIENT_SECRET || 'YOUR_BOT_CLIENT_SECRET';
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000/auth/callback';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const authService = {
  login() {
    const scope = 'identify guilds email';
    const state = Math.random().toString(36).substring(7);
    localStorage.setItem('oauth_state', state);
    
    // Debug logging
    console.log('Client ID:', DISCORD_CLIENT_ID);
    console.log('Redirect URI:', REDIRECT_URI);
    
    const authUrl = `https://discord.com/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=code&scope=${scope}&state=${state}`;
    
    console.log('Auth URL:', authUrl);
    
    window.location.href = authUrl;
  },

  // Simplified exchangeCode for demo - in production, this should be handled by your backend
  async exchangeCode(code, state) {
    const storedState = localStorage.getItem('oauth_state');
    if (state !== storedState) {
      throw new Error('Invalid state parameter');
    }

    try {
      // For demo purposes, we'll create a mock user
      // In production, this should call your backend API
      console.log('Exchanging code for token (mock implementation)');
      
      // Mock successful token exchange
      const mockUser = {
        id: '1138193657825075332',
        username: 'DemoUser',
        discriminator: '0001',
        avatar: null,
        email: 'demo@example.com'
      };

      return {
        access_token: 'mock_token_' + Date.now(),
        user: mockUser
      };
    } catch (error) {
      throw new Error('Failed to exchange code for token');
    }
  },

  async getUserInfo(token) {
    try {
      const response = await axios.get('https://discord.com/api/users/@me', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to get user info');
    }
  },

  async getBotData(token) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/user/data`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw new Error('Failed to get bot data');
    }
  }
};
